import { render, staticRenderFns } from "./CovidGrant.vue?vue&type=template&id=402e3e8b&scoped=true&"
import script from "./CovidGrant.vue?vue&type=script&lang=js&"
export * from "./CovidGrant.vue?vue&type=script&lang=js&"
import style0 from "./CovidGrant.vue?vue&type=style&index=0&id=402e3e8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e3e8b",
  null
  
)

export default component.exports